import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% di sconto sugli articoli selezionati',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: "{{percentage}}% di sconto sul valore totale dell'ordine",
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Articolo gratuito con un articolo',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: "Articolo gratuito con un valore d'ordine",
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Compra uno prendi uno a metà prezzo',
  [OFFER_KIND.BOGO]: 'Compra uno prendi uno gratis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} di sconto sugli articoli selezionati',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: "{{amount}} di sconto con un valore d'ordine",
};
